import {tap} from 'rxjs/operators';
import { HttpInterceptor, HTTP_INTERCEPTORS, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { LoadingService } from './loading-service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    private uuid;

    constructor(private loadingService: LoadingService) {
        this.uuid = uuid();
        // console.warn('Inicializando LoadingInterceptor: ', this.uuid);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let telaBloqueia = shouldBlockInterface(req);
        if (telaBloqueia) {
            // console.warn('Bloqueando tela LoadingInterceptor: ', this.uuid);
            this.loadingService.bloqueiaTela();
        }

        // Libera a tela no callback de erro e de complete
        return next.handle(req).pipe(tap(() => {},
            (error) => {
                if(telaBloqueia){
                    this.loadingService.liberaTela();
                }
            },
            () => {
                if(telaBloqueia){
                    this.loadingService.liberaTela();
                }
            }
        ));
    }

}

const UI_BLOCK_HEADER = 'x-ui-block';

export function blockUi(options: any = {headers: {}, params: {}}): {} {
    return addHeader(options, UI_BLOCK_HEADER, true.toString());
}

export function addHeader(options: any = {headers: {}, params: {}}, header: string, value: string): {} {    
    if (options == null)
    {
        options = {};
    }
    if (options['headers'] instanceof HttpHeaders) {
        let httpHeaders = (options['headers'] as HttpHeaders);
        httpHeaders= httpHeaders.append(header, value);
        options['headers'] = httpHeaders;
    } else {
        options['headers'] = options['headers'] || {};
        options['headers'][header] = value;
    }
    return options;
}

function shouldBlockInterface(req: HttpRequest<any>): boolean {
    return req.headers.get(UI_BLOCK_HEADER) === true.toString();
}


export let LoadingInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptor,
    multi: true
};
